import React, { useState } from "react"
import { addFlight, updateFlight } from "../../../lib/actions"
import { fetchFlights } from "../../../lib/queries"
import AdminTable from '../../../components/AdminTable'
import FlightModal from './FlightModal'
import { useInfiniteScroll } from '../../../hooks/useInfiniteScroll'

const CREATE_ACTION = "create"
const UPDATE_ACTION = "update"

function FlightsTable() {
    const [searchTerm, setSearchTerm] = useState("")
    const [showModal, setShowModal] = useState(false)

    const {
        items: flights,
        ref,
        isLoading,
        isError,
        error,
        isFetchingNextPage,
        refetch,
        hasNextPage
    } = useInfiniteScroll('flights', fetchFlights)

    const toggleModal = (modalName) => {
        if (modalName === showModal) {
            setShowModal(false)
        } else {
            setShowModal(modalName)
        }
    }

    const handleSubmit = async (data, action) => {
        try {
            if (action === UPDATE_ACTION) {
                await updateFlight(data.id, data)
            } else if (action === CREATE_ACTION) {
                await addFlight(data)
            }
            await refetch()
            setShowModal(false)
        } catch (error) {
            console.error("Error saving flight:", error)
        }
    }

    const filteredFlights = flights.filter((flight) =>
        !searchTerm ||
        flight.flightNo.toLowerCase().includes(searchTerm.toLowerCase())
    )

    if (isLoading) return <div>Loading...</div>
    if (isError) return <div>Error: {error.message}</div>

    return (
        <section>
            <div className="row mb-3">
                <div className="col-md-4">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search by Flight Number"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
                {showModal === "createFlight" && <FlightModal
                    isOpen={showModal === "createFlight"}
                    onClose={() => toggleModal("createFlight")}
                    mode={CREATE_ACTION}
                    onSubmit={(data) => handleSubmit(data, CREATE_ACTION)}
                />}
                <div className="col-md-4 ms-auto text-end">
                    <button
                        className="btn btn-primary"
                        onClick={() => toggleModal("createFlight")}
                    >
                        Add New Flight
                    </button>
                </div>
            </div>

            <AdminTable>
                <thead className="thead-light">
                    <tr>
                        <th>#</th>
                        <th>Flight No</th>
                        <th>Departure</th>
                        <th>Arrival</th>
                        <th>Airline Logo</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredFlights.map((flight, index) => (
                        <tr key={flight.id}>
                            <td>{index + 1}</td>
                            <td>{flight.flightNo}</td>
                            <td>{flight.departure}</td>
                            <td>{flight.arrival}</td>
                            <td>
                                {flight.airlineLogo ? (
                                    <img
                                        src={flight.airlineLogo}
                                        alt={`${flight.flightNo} logo`}
                                        style={{
                                            width: '50px',
                                            height: '30px',
                                            objectFit: 'contain',
                                            borderRadius: '4px'
                                        }}
                                        onError={(e) => {
                                            e.target.style.display = 'none'
                                            e.target.nextSibling.style.display = 'inline'
                                        }}
                                    />
                                ) : (
                                    <span className="text-muted">No logo</span>
                                )}
                            </td>
                            <td>
                                {showModal === "editFlight" + index && <FlightModal
                                    isOpen={showModal === "editFlight" + index}
                                    onClose={() => toggleModal("editFlight" + index)}
                                    mode={UPDATE_ACTION}
                                    flightData={flight}
                                    onSubmit={(data) => handleSubmit(data, UPDATE_ACTION)}
                                />}
                                <span
                                    className="material-symbols-outlined text-primary-color"
                                    onClick={() => toggleModal("editFlight" + index)}
                                    style={{ cursor: "pointer" }}
                                >
                                    edit
                                </span>
                            </td>
                        </tr>
                    ))}
                    <tr ref={ref}>
                        <td colSpan="5">
                            {isFetchingNextPage ? (
                                <div className="text-center py-2">
                                    <div className="spinner-border spinner-border-sm" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            ) : hasNextPage ? (
                                <div className="text-center py-2 text-muted">
                                    Scroll for more...
                                </div>
                            ) : (
                                <div className="text-center py-2 text-muted">
                                    No more records to load
                                </div>
                            )}
                        </td>
                    </tr>
                </tbody>
            </AdminTable>
        </section>
    )
}

export default FlightsTable 